
$(function () {
    $(".btn").click(function () {
        
        if ($(this).is("[data-loader=true]")) {
            var _self = this;
            var $form = $(this).parents("form");
            const formId = $(this).attr("form");

            //attempt to grab the form from the form attribute (if any)
            if ((!$form || $form.length < 1) && formId) {
                $form = $("#" + formId);
            }

            if ($form && $form.length > 0 && !$form.eq(0).valid()) {
                return;
            }

            setTimeout(function () {
                $(_self).addClass("btn-loading")
                    .children("span")
                    .removeClass(function (idx, className) {
                        return (className.match(/(^|\s)glyphicon\S+/g) || []).join(' ');
                    })
                    .removeClass(function (idx, className) {
                        return (className.match(/(^|\s)fa\S+/g) || []).join(' ');
                    })
                    .first()
                    .addClass("fas fa-spinner");

                if ($(_self).is("a")) $(_self).addClass("disabled");
                if ($(_self).is("button")) $(_self).attr("disabled", "disabled");
            }, 200)
        }
    });
})